import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";

const PolitykaPrywatnosci = () => {
  return (
    <Layout>
      <SEOHead
        title="Polityka Prywatności | naklejki-3d.com.pl"
        description="Polityka prywatności naklejki-3d.com.pl – informacje o przetwarzaniu danych osobowych zgodnie z RODO."
      />
      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4 max-w-3xl">
          <h1 className="text-3xl lg:text-4xl font-bold text-foreground mb-8">Polityka Prywatności</h1>

          <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
            <p className="text-sm">Ostatnia aktualizacja: 23 lutego 2026</p>

            <h2 className="text-xl font-semibold text-foreground mt-8">1. Administrator danych</h2>
            <p>Administratorem Twoich danych osobowych jest DRUKEXPERT.PL Sp. z o.o. (NIP: 954 287 50 30). Kontakt: biuro@projekt-art.pl, tel. +48 534 900 620.</p>

            <h2 className="text-xl font-semibold text-foreground mt-8">2. Jakie dane zbieramy</h2>
            <p>Zbieramy dane, które przekazujesz nam dobrowolnie poprzez formularze kontaktowe i zamówieniowe:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Imię i nazwisko</li>
              <li>Adres e-mail</li>
              <li>Numer telefonu</li>
              <li>Dane firmy (NIP, nazwa, adres)</li>
              <li>Treść wiadomości</li>
            </ul>

            <h2 className="text-xl font-semibold text-foreground mt-8">3. Cel przetwarzania danych</h2>
            <p>Twoje dane przetwarzamy w celu:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Realizacji zamówień i wycen</li>
              <li>Odpowiedzi na zapytania kontaktowe</li>
              <li>Wystawiania faktur i dokumentów księgowych</li>
              <li>Marketingu bezpośredniego (za Twoją zgodą)</li>
            </ul>

            <h2 className="text-xl font-semibold text-foreground mt-8">4. Podstawa prawna</h2>
            <p>Przetwarzanie odbywa się na podstawie art. 6 ust. 1 RODO: zgoda (lit. a), wykonanie umowy (lit. b), obowiązek prawny (lit. c) oraz prawnie uzasadniony interes administratora (lit. f).</p>

            <h2 className="text-xl font-semibold text-foreground mt-8">5. Okres przechowywania</h2>
            <p>Dane przechowujemy przez okres niezbędny do realizacji celów przetwarzania, nie dłużej niż wymagają tego przepisy prawa (np. dokumentacja księgowa – 5 lat).</p>

            <h2 className="text-xl font-semibold text-foreground mt-8">6. Twoje prawa</h2>
            <p>Masz prawo do: dostępu do swoich danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia danych, wniesienia sprzeciwu oraz cofnięcia zgody w dowolnym momencie.</p>

            <h2 className="text-xl font-semibold text-foreground mt-8">7. Odbiorcy danych</h2>
            <p>Dane mogą być przekazywane podmiotom świadczącym usługi na naszą rzecz: hosting, księgowość, kurierzy. Nie przekazujemy danych do państw trzecich.</p>

            <h2 className="text-xl font-semibold text-foreground mt-8">8. Kontakt</h2>
            <p>W sprawach związanych z ochroną danych osobowych prosimy o kontakt: biuro@projekt-art.pl.</p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PolitykaPrywatnosci;
